import { render, staticRenderFns } from "./paginationMovimentacao.vue?vue&type=template&id=425b76fe&"
import script from "./paginationMovimentacao.vue?vue&type=script&lang=js&"
export * from "./paginationMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports